"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _cuid = _interopRequireDefault(require("cuid"));

var ProfileUserFill = function ProfileUserFill(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, props, {
    uniqueId: uniqueId,
    iconName: "ProfileUserFill"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "10",
    cy: "4.5",
    r: "4.5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.18,14.73c-2.35-4.6-6.49-4.48-8.15-4.48s-5.86-.12-8.21,4.48C.59,17.14,1.29,20,4.54,20H15.46C18.71,20,19.41,17.14,18.18,14.73Z",
    fill: "url(#".concat(uniqueId, ")")
  }));
};

var _default = ProfileUserFill;
exports["default"] = _default;